"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, Markdown, TextBody, TextHeading, tv } from "@opensea/ui-kit";
import { createContext, useContext } from "react";

// TODO: Implement editing states

// TODO: Context will eventually contain editing props and handlers
const NarrativeTextContext = createContext({
  horizontalTextPosition: "LEFT",
  variant: undefined
});
const narrativeTextContainerVariants = tv({
  base: "relative size-full",
  variants: {
    verticalTextPosition: {
      TOP: "justify-start",
      CENTER: "justify-center",
      BOTTOM: "justify-end"
    },
    horizontalTextPosition: {
      LEFT: "items-start",
      CENTER: "items-center",
      RIGHT: "items-end"
    },
    variant: {
      TEXT: "",
      TEXT_AND_MEDIA: "",
      TEXT_AND_BACKGROUND: "",
      BACKGROUND: ""
    }
  },
  compoundVariants: [{
    horizontalTextPosition: "RIGHT",
    variant: "TEXT_AND_MEDIA",
    class: "items-start"
  }]
});
const textVariants = tv({
  base: "text-left",
  variants: {
    horizontalTextPosition: {
      LEFT: "",
      CENTER: "text-center [&>p]:w-full",
      RIGHT: ""
    }
  }
});
function NarrativeTextContainer(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("flex flex-col", "gap-1 lg:gap-2", "relative", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <FlexColumn className={t1} {...props}>{children}</FlexColumn>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function NarrativeTextOrInput(t0) {
  const $ = _c(17);
  const {
    children,
    className,
    horizontalTextPosition,
    verticalTextPosition,
    variant,
    textContainerClassName
  } = t0;
  let t1;
  if ($[0] !== horizontalTextPosition || $[1] !== variant) {
    t1 = {
      horizontalTextPosition,
      variant
    };
    $[0] = horizontalTextPosition;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className || $[4] !== horizontalTextPosition || $[5] !== variant || $[6] !== verticalTextPosition) {
    t2 = classNames(narrativeTextContainerVariants({
      verticalTextPosition,
      horizontalTextPosition,
      variant
    }), className);
    $[3] = className;
    $[4] = horizontalTextPosition;
    $[5] = variant;
    $[6] = verticalTextPosition;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== textContainerClassName) {
    t3 = <NarrativeTextContainer className={textContainerClassName}>{children}</NarrativeTextContainer>;
    $[8] = children;
    $[9] = textContainerClassName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <FlexColumn className={t2}>{t3}</FlexColumn>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t4) {
    t5 = <NarrativeTextContext.Provider value={t1}>{t4}</NarrativeTextContext.Provider>;
    $[14] = t1;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export function NarrativeTextOrInputHeading(t0) {
  const $ = _c(6);
  const {
    className,
    value
  } = t0;
  const {
    horizontalTextPosition
  } = useContext(NarrativeTextContext);
  let t1;
  if ($[0] !== className || $[1] !== horizontalTextPosition) {
    t1 = classNames(textVariants({
      horizontalTextPosition
    }), className);
    $[0] = className;
    $[1] = horizontalTextPosition;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== value) {
    t2 = <TextHeading className={t1} size="lg">{value}</TextHeading>;
    $[3] = t1;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function NarrativeTextOrInputBody(t0) {
  const $ = _c(8);
  const {
    className,
    value
  } = t0;
  const {
    horizontalTextPosition
  } = useContext(NarrativeTextContext);
  const text = value ?? "";
  let t1;
  if ($[0] !== className || $[1] !== horizontalTextPosition) {
    t1 = classNames(textVariants({
      horizontalTextPosition
    }), className);
    $[0] = className;
    $[1] = horizontalTextPosition;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== text) {
    t2 = <Markdown>{text}</Markdown>;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <TextBody asChild={true} className={t1} size="md">{t2}</TextBody>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export { NarrativeTextOrInput };